import clsx from "clsx"
import React from "react"

interface CircularLoaderProps {
  size?: "sm" | "md" | "lg" | "xl"
  className?: string
}

const CircularLoader: React.FC<CircularLoaderProps> = ({ className, size = "md", }) => {

  const sizeClasses = {
    sm: "w-4 h-4 ",
    md: "w-8 h-8 ",
    lg: "w-12 h-12 ",
    xl: "w-[100px] h-[100px] ",
  };
 const strokeWidths = {
    sm: "4",
    md: "6",
    lg: "8",
    xl: "16",
  }
  const radiusValues = {
    sm: 28,
    md: 42,
    lg: 56,
    xl: 100,
  }

  const circumference = 2 * Math.PI * radiusValues[size]
  const dashArray = circumference * 0.9 
  const dashOffset = circumference * 0.1 

  const containerClasses = clsx(
    "flex justify-center items-center",
    className,
  )

  return (
    <div className={containerClasses}>
      <div className={clsx("relative", sizeClasses[size])}>
        <div className="absolute inset-0 animate-spin">
          <svg className="w-full h-full" viewBox={`0 0 ${radiusValues[size] * 2 + 20} ${radiusValues[size] * 2 + 20}`}>
            <defs>
              <linearGradient id={`mainArc-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="50%" stopColor="#5DA2FF" />
                <stop offset="50%" stopColor="#5DA2FF4D" />
              </linearGradient>
            </defs>
            <circle
              cx={radiusValues[size] + 10}
              cy={radiusValues[size] + 10}
              r={radiusValues[size]}
              fill="none"
              stroke={`url(#mainArc-${size})`}
              strokeWidth={strokeWidths[size]}
              strokeLinecap="round"
              strokeDasharray={dashArray}
              strokeDashoffset={dashOffset}
              transform={`rotate(-90 ${radiusValues[size] + 10} ${radiusValues[size] + 10})`}
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default CircularLoader

